const congress = 'apvrs';


var dates = [
  {name: "2018-02-08"},
  {name: "2018-02-09"},
  {name: "2018-02-10"},
  {name: "2018-02-11"},
];

var url = 'https://congress.apaophth.org/mobile/session?eventShortCode=apao2018';
var abstractUrl = 'https://congress.apaophth.org/mobile/abstract?eventShortCode=apao2018';
var bannerUrl = 'https://2018.apaophth.org';

var venues = [
  { id: 1, name: "Grand Ballroom" },
  { id: 2, name: "Salon I" }
];

var timeslots = [
  {id: 1, startTime: "11:00", endTime: "12:00", for: 'all'},
  {id: 2, startTime: "13:30", endTime: "15:15", for: 'all'},
  {id: 4, startTime: "15:45", endTime: "17:10", for: 'all'},
  {id: 5, startTime: "09:00", endTime: "10:30", for: 'all'},
  {id: 6, startTime: "11:00", endTime: "12:35", for: 'all'},
  {id: 7, startTime: "14:00", endTime: "15:35", for: 'all'}
];

var tabList = [
  {id: 1, name: "Program in Calendar View"},
  {id: 2, name: "Program-at-a-Glance View"},
  {id: 3, name: "Search by Speaker Name"},
  // {id: 4, name: "Posters", abstractType: "Poster"},
  // {id: 5, name: "e-Posters", abstractType: "E-Poster"},
  // {id: 6, name: "Videos", abstractType: "Video"}
];

switch (congress) {
  case 'aptos':
    url = 'http://congress.asiateleophth.org/mobile/session?eventShortCode=aptos2017';
    abstractUrl = 'http://congress.asiateleophth.org/mobile/abstract?eventShortCode=aptos2017';
    bannerUrl = 'http://2017.asiateleophth.org';
    dates = [
      {name: "2017-07-15"},
      {name: "2017-07-16"}
    ];
    venues = [
      { id: 1, name: "Grand Ballroom" },
      { id: 2, name: "Salon I" }
    ];
    timeslots = [
      {id: 1, startTime: "11:00", endTime: "12:00", for: '2017-07-15'},
      {id: 2, startTime: "13:30", endTime: "15:15", for: '2017-07-15'},
      {id: 4, startTime: "15:45", endTime: "17:15", for: '2017-07-15'},
      {id: 5, startTime: "09:00", endTime: "10:30", for: '2017-07-16'},
      {id: 6, startTime: "11:00", endTime: "12:30", for: '2017-07-16'},
      {id: 7, startTime: "14:00", endTime: "15:30", for: '2017-07-16'}
    ];
    tabList = [
      {id: 1, name: "Program in Calendar View"},
      {id: 2, name: "Program-at-a-Glance View"},
      {id: 3, name: "Search by Speaker Name"},
      {id: 5, name: "e-Posters", abstractType: "E-Poster"},
      {id: 6, name: "Videos", abstractType: "Video"}
    ];
    break;
  case 'apvrs':
    url = 'https://congress.apvrs.org/mobile/session?eventShortCode=apvrs2019';
    abstractUrl = 'https://congress.apvrs.org/mobile/abstract?eventShortCode=apvrs2019';
    bannerUrl = 'https://2019.apvrs.org';
    dates = [
      {name: "2019-11-22"},
      {name: "2019-11-23"},
      {name: "2019-11-24"}
    ];
    venues = [
      { id: 1, name: "Session Room 1" },
      { id: 2, name: "Session Room 2" },
      { id: 3, name: "Session Room 3" },
      { id: 4, name: "Session Room 4" },
      { id: 5, name: "Session Room 5" }
    ];
    timeslots = [
      {id: 1, startTime: "08:30", endTime: "10:00", for: 'all'},
      {id: 2, startTime: "10:15", endTime: "11:45", for: 'all'},
      {id: 3, startTime: "14:30", endTime: "16:00", for: 'all'},
      {id: 4, startTime: "16:00", endTime: "17:00", for: 'all'}
    ];
    tabList = [
      {id: 1, name: "Program in Calendar View"},
      {id: 2, name: "Program-at-a-Glance View"},
      {id: 3, name: "Search by Speaker Name"},
      {id: 4, name: "Posters", abstractType: "Poster"},
      {id: 5, name: "e-Posters", abstractType: "E-Poster"},
      {id: 6, name: "Videos", abstractType: "Video"}
    ];
    break;
  case 'apspos':
    url = 'http://congress.apspos.org/mobile/session?eventShortCode=apspos2017';
    abstractUrl = 'http://congress.apspos.org/mobile/abstract?eventShortCode=apspos2017';
    bannerUrl = 'http://2017.apspos.org';
    dates = [
      {name: "2017-10-11"},
      {name: "2017-10-12"}
    ];
    venues = [
      { id: 1, name: "Main Lecture Hall" },
      { id: 2, name: "Room 428" },
      { id: 3, name: "Room 308"}
    ];
    timeslots = [
      {id: 1, startTime: "08:45", endTime: "10:00", for: '2017-10-11'},
      {id: 2, startTime: "10:00", endTime: "10:30", for: '2017-10-11'},
      {id: 3, startTime: "10:30", endTime: "10:45", for: '2017-10-11'},
      {id: 4, startTime: "11:00", endTime: "12:15", for: '2017-10-11'},
      {id: 14, startTime: "12:15", endTime: "13:15", for: '2017-10-11'},
      {id: 5, startTime: "13:30", endTime: "14:45", for: '2017-10-11'},
      {id: 10, startTime: "15:00", endTime: "15:30", for: '2017-10-11'},
      {id: 6, startTime: "15:00", endTime: "16:15", for: '2017-10-11'},
      {id: 11, startTime: "16:30", endTime: "17:00", for: '2017-10-11'},
      {id: 12, startTime: "08:45", endTime: "09:15", for: '2017-10-12'},
      {id: 7, startTime: "08:45", endTime: "10:15", for: '2017-10-12'},
      {id: 13, startTime: "10:45", endTime: "11:15", for: '2017-10-12'},
      {id: 8, startTime: "10:45", endTime: "12:15", for: '2017-10-12'},
      {id: 15, startTime: "12:15", endTime: "13:15", for: '2017-10-12'},
      {id: 16, startTime: "13:30", endTime: "14:30", for: '2017-10-12'},
      {id: 9, startTime: "13:30", endTime: "15:30", for: '2017-10-12'},
    ];
    tabList = [
      {id: 1, name: "Program in Calendar View"},
      {id: 2, name: "Program-at-a-Glance View"},
      {id: 3, name: "Search by Speaker Name"},
      {id: 4, name: "Posters", abstractType: "Poster"},
      {id: 5, name: "e-Posters", abstractType: "E-Poster"},
      {id: 6, name: "Videos", abstractType: "Video"}
    ];
    break;
  default: 
    break;
}




var defaultDate = dates[0].name;

export default {
  defaultDate: defaultDate,
  dates: dates,
  venues: venues,
  timeslots: timeslots,
  tabList: tabList,
  url: url,
  abstractUrl: abstractUrl,
  bannerUrl: bannerUrl
};



/** WEBPACK FOOTER **
 ** ./src/js/config.js
 **/